import { map } from 'nanostores';
import type { PageSettingsModel } from '../models/PageSettingsModel';
import { createUniversalStore } from './createUniversalStore';

const store = map<PageSettingsModel>({
    country: 'fr',
    language: 'fr-FR',
    platform: { site: 'www.laredoute.fr', type: 'web' },
    userAgent: '',
    requestTraceId: '',
    isCerberusBot: false,
    isTranscluded: false,
    tracking: { rootData: { siteSection: 'unknown', page: 'unknown' } },
    abVariation: null
});

export const $pageSettings = createUniversalStore('pageSettings', store);
